import { useEffect, useRef } from "react";

export function parseVideo(url = "") {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return { type: "youtube", src: `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0&modestbranding=1` };
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return { type: "vimeo", src: `https://player.vimeo.com/video/${vm[1]}?dnt=1` };
  if (/iframe|embed|player\./.test(url) && !/\.(mp4|webm|m3u8)/.test(url)) return { type: "iframe", src: url };
  return { type: "file", src: url };
}

export default function VideoPlayer({ url, poster, startAt = 0, onProgress, onEnded, title = "Video" }) {
  const ref = useRef(null);
  const last = useRef(0);
  const v = parseVideo(url);

  useEffect(() => {
    if (ref.current && startAt > 5) ref.current.currentTime = startAt;
  }, [startAt, url]);

  if (!url) return <div className="aspect-video bg-black rounded-xl flex items-center justify-center text-slate-500">No video yet</div>;
  if (v.type !== "file")
    return (
      <div className="aspect-video rounded-xl overflow-hidden bg-black border border-white/10" data-testid="video-player">
        <iframe src={v.src} title={title} className="w-full h-full" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowFullScreen />
      </div>
    );
  return (
    <div className="aspect-video rounded-xl overflow-hidden bg-black border border-white/10" data-testid="video-player">
      <video
        ref={ref}
        src={v.src}
        poster={poster}
        controls
        playsInline
        className="w-full h-full"
        onTimeUpdate={(e) => {
          const t = e.target.currentTime;
          if (onProgress && Math.abs(t - last.current) > 10) {
            last.current = t;
            onProgress(t, e.target.duration || 0);
          }
        }}
        onEnded={(e) => onEnded?.(e.target.duration || 0)}
      />
    </div>
  );
}
